import { useEffect } from "react";

const TawkToWidget = () => {
  useEffect(() => {
    const tawkScript = document.createElement("script");
    tawkScript.async = true;
    tawkScript.src = "https://embed.tawk.to/67406f242480f5b4f5a26fd8/1id9r4aej";
   // tawkScript.src = "https://embed.tawk.to/68849fe9e7e6321928ba9145/1j1311acm";
    tawkScript.charset = "UTF-8";
    tawkScript.setAttribute("crossorigin", "*");

    document.body.appendChild(tawkScript);

    // Wait for Tawk_API to be ready and then hide the widget
    const tryHideWidget = () => {
      if (window.Tawk_API && typeof window.Tawk_API.hideWidget === "function") {
        window.Tawk_API.hideWidget();
      } else {
        setTimeout(tryHideWidget, 200); // Retry until it loads
      }
    };

    tryHideWidget();

    return () => {
      document.body.removeChild(tawkScript);
    };
  }, []);

  return null;
};

export default TawkToWidget;
